import { Dataset } from "@/models/dataset";
import { Component, Vue, Prop } from "vue-facing-decorator";
import { useGlobalStore } from "@/stores/store";

import ResultsMinimap from "@/components/results-minimap/ResultsMinimap.vue";


@Component({
    name: "VsResultMap",
    emits: ["document-hovered"],
    components: {
        ResultsMinimap
    },
})
export default class VsResultMap extends Vue {
    public openAccessLicences: Array<string> = ["CC-BY-4.0", "CC-BY-SA-4.0"];
    store = useGlobalStore;

    @Prop()
    private datasets!: Array<Dataset>;

    public get results(): Array<Dataset> {
        return this.datasets;
    }

    onDocumentHover(document: any) {
        // console.log("Document hover event triggered", document);
        
        if (document.bbox_xmin && document.bbox_xmax && document.bbox_ymin && document.bbox_ymax) {
            const bbox = {
                xmin: parseFloat(document.bbox_xmin),
                ymin: parseFloat(document.bbox_ymin),
                xmax: parseFloat(document.bbox_xmax),
                ymax: parseFloat(document.bbox_ymax),
            };
            this.$emit("document-hovered", bbox);
            // this.store.hoveredBbox = bbox; // <-- Store in global store
            // console.log("Hovered document bbox:", bbox);
        }
    }

    onDocumentLeave() {
        // console.log("Document leave event triggered");
        
        this.$emit("document-hovered", null); // Clear the polygon when the mouse leaves
        // this.store.hoveredBbox = null; // <-- Clear on leave
    }

    onDocumentClick(document: any) {
        // console.log("Document click event triggered");
        
        if (document.bbox_xmin && document.bbox_xmax && document.bbox_ymin && document.bbox_ymax) {
            const bbox = {
                xmin: parseFloat(document.bbox_xmin),
                ymin: parseFloat(document.bbox_ymin),
                xmax: parseFloat(document.bbox_xmax),
                ymax: parseFloat(document.bbox_ymax),
            };
            // this.store.hoveredBbox = bbox; // <-- Store in global store
            this.store.resultsForMap = [{id: 0, bbox_xmin: document.bbox_xmin, bbox_xmax: document.bbox_xmax, bbox_ymin: document.bbox_ymin, bbox_ymax: document.bbox_ymax}];
            console.log("results emptied");
            
            // this.store.resultsForMap.push({id: 0, bbox_xmin: document.bbox_xmin, bbox_xmax: document.bbox_xmax, bbox_ymin: document.bbox_ymin, bbox_ymax: document.bbox_ymax});
        }
    }

    /* Provides the bounds of the publication for the Leaflet minimap */
    public getBounds(document: Dataset): L.LatLngBoundsLiteral | string {
        // if (this.coverage != undefined) { 
            return [
                [Number(document.bbox_ymin), Number(document.bbox_xmin)], // Southwest corner
                [Number(document.bbox_ymax), Number(document.bbox_xmax)]  // Northeast corner
            ];
        // } else {
        //     return ""; 
        // }
    }

    public simplifyAuthor(author:string): string {
        
        if (author.endsWith(" ")) { 
            return author.substring(0, author.indexOf(","));
        } else {
            let firstNameInitial:string = author.charAt(author.indexOf(",") + 2);
            return author.substring(0, author.indexOf(",") + 2) + firstNameInitial;
        }
    }

    public getDomainWithoutSubdomain(): string {
        const urlParts = new URL(window.location.href).hostname.split(".");

        return urlParts
            .slice(0)
            .slice(-(urlParts.length === 4 ? 3 : 2))
            .join(".");
    }

    // private convert(unixtimestamp: number): string { // SOLR
    private convert(unixtimestamp: string, locale: string): string { // OpenSearch
        // Unixtimestamp
        // var unixtimestamp = document.getElementById('timestamp').value;
        // Months array
        let months_arr = [];
        if (locale == "DE") {
            months_arr = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
        } else {
            months_arr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        }
        // Convert timestamp to milliseconds
        // const date = new Date(unixtimestamp * 1000); // SOLR
        const date = new Date(Number(unixtimestamp) * 1000); // OpenSearch
        // Year
        const year = date.getFullYear();
        // Month
        const month = months_arr[date.getMonth()];
        // Day
        const day = date.getDate();
        // Display date time in MM-dd-yyyy h:m:s format
        const convdataTime = month + " " + day + ", " + year;
        // document.getElementById('datetime').innerHTML = convdataTime;
        return convdataTime;
    }

}
